module.exports = __webpack_public_path__ + "img/bild-b.02446aac.png";